import { render, staticRenderFns } from "./Bold.vue?vue&type=template&id=a745b7d4&scoped=true&"
import script from "./Bold.vue?vue&type=script&lang=js&"
export * from "./Bold.vue?vue&type=script&lang=js&"
import style0 from "./Bold.vue?vue&type=style&index=0&id=a745b7d4&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a745b7d4",
  null
  
)

export default component.exports